<template>
  <div>
    <Toolbar />
    <v-img :src="imagen" width="100%"></v-img>

    <div
      v-if="!imagen"
      class="d-flex flex-row justify-center align-center hazmeCaso"
    >
      <v-row justify="center">
        <v-col cols="8" xs="8" sm="8" md="3" lg="3" xl="3">
          <v-icon
            color="grey darken-3"
            size="200"
            class="d-flex flex-row justify-center align-center"
            >mdi-image-broken
          </v-icon>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
export default {
  name: 'Comprobante',
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  data: () => {
    return {
      imagen: null,
    }
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'LayoutDocumento')
    this.imagen =
      'data:image/jpg;base64,' +
      this.$store.getters['personaDocumentos/obtenerComprobanteBase64']
  },
}
</script>

<style>
.hazmeCaso {
  bottom: 0;
  display: block;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}
</style>
